export default __webpack_public_path__ + "static/media/roof.c0d4cbc5.png";